export const ordinalify = n => {
  switch (n % 10) {
    case 1:
      return `${n}st`

    case 2:
      return n === 12 ? `12th` : `${n}nd`

    case 3:
      return `${n}rd`

    default:
      return `${n}th`
  }
}

export const createMarkup = (markup) => {
  return {
    __html: markup
  }
}



// WEBPACK FOOTER //
// ./src/util.js